import AppData from "../../../public/const/app_data";

const {ccclass, property} = cc._decorator;

@ccclass
export default class HallGameIcon extends cc.Component {
    @property(cc.Label)
    labelLevelLock:cc.Label = null;

    @property(cc.Node)
    maskNode:cc.Node = null;

    @property(cc.Button)
    button:cc.Button = null;

    @property(dragonBones.ArmatureDisplay)
    dragon:dragonBones.ArmatureDisplay=null

    @property(cc.Node)
    tag:cc.Node = null;

    updateLvLock(levelLock:number){
        if (levelLock > 0) {
            this.labelLevelLock.string = "Lv" + levelLock
            this.labelLevelLock.node.parent.active = true
        } else {
            this.labelLevelLock.node.parent.active = false
        }
        if (AppData.startCheckGame){
            this.isShowGame(false);
            this.isShowTag(true)
        }else{
            this.isShowGame(levelLock > 0);
            this.isShowTag(levelLock <= 0)
        }
    }

    private isShowTag(isShow:boolean){
        if (this.tag) {
            this.tag.active = isShow;
        }
    }

    private isShowGame(isNoOpen:boolean){
        this.labelLevelLock.node.parent.active = isNoOpen;
        this.maskNode.active = isNoOpen;
        //this.button.interactable = isNoOpen;

        let animSate = this.dragon.playAnimation(this.dragon.animationName,-1)
        if (!isNoOpen) {
            animSate.play();
        }else{
            animSate.stop();
        }
    }


    setName(nameStr:string,dragonAssets,AtlasAsset, levelLock : number) {

    }
    
}
